import { Component, OnInit, Input, Inject, ElementRef, ViewChild } from '@angular/core';
import { CMSPortalService } from '../shared/service/cms-portal.service';
import { Noticia } from '../shared/model/noticia.model';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.css']
})
export class NoticiasComponent implements OnInit {
  @ViewChild('listaNoticias') listaNoticiasEL: ElementRef;
  @Input() limit = 0;
  noticias: Array<Noticia>;

  constructor(private service: CMSPortalService,
              private router: Router,
              private http: HttpClient,
              @Inject('CMS_HOST') private host: string) { }

  ngOnInit() {
    this.listarNoticias();
  }

  listarNoticias() {
    this.service.getNoticias().subscribe(res => {
      const conteudo: Array<Noticia> = res.conteudo;
      if (this.limit > 0 && conteudo.length > this.limit) {
        this.noticias = conteudo.slice(0, this.limit);
      } else {
        this.noticias = res.conteudo;
        setTimeout(() => {
          this.carregarPaginacao();
        }, 100);
      }
    });
  }

  carregarPaginacao() {
    this.http.get('content/js/pagination-noticia.js', {responseType: 'text'}).subscribe(file => {
      const js = '<script type="text/javascript">' +
                    file +
                  '</script>';
      const fragment = document.createRange().createContextualFragment(js);
      this.listaNoticiasEL.nativeElement.appendChild(fragment);
    });
  }

  abrirNoticia(noticia: Noticia) {
    this.router.navigate(['/noticia', noticia.id]);
  }

  buscaImagemNoticia(noticia: Noticia): string {
    const imagens = noticia.imagens.sort((a, b) => a.capa > b.capa ? -1 : a.capa < b.capa ? 1 : 0);
    return this.host + imagens[0].url;
  }

}
